import { combine, filter, pipe, publish, Source, subscribe, tap } from 'wonka';

import { addOptions, getEnvironment } from './environment';
import { resizeAdvert } from './size';
import { Tag } from './tag';
import { resize$, unload$ } from './utils/events';
import { tcfData$ } from './third-party/tcf';

export const lifecycle = (tags$: Source<Tag[]>) => {
  const environment = getEnvironment();

  // GDPR consent can be changed or withdrawn at any time, so we need to
  // update our options over the lifetime of the advert on the page
  // We should do this before subscribing to the tag source so that we can
  // ensure the GDPR options are set before tag data is requested from the server
  const unsubscribeTcf = pipe(
    tcfData$(),
    subscribe(({ gdprApplies, tcString }) => {
      addOptions({ gdpr: `${Number(gdprApplies)}`, gdpr_consent: tcString });
    }),
  );

  // tags$ sink to start tags rendering to the page
  const unsubscribeTags = pipe(
    tags$,
    subscribe(() => {}),
  );

  // Listen for resize events and resize each tag to fit the space
  const onResize = pipe(
    combine(resize$(getEnvironment().topWindow), tags$),
    filter(() => !environment.safeFrame),
    tap(([, tags]) => tags.forEach(resizeAdvert)),
    subscribe(() => {}),
  );

  // Cleanup
  const onUnload = pipe(
    combine(unload$(environment.currentWindow), tags$),
    subscribe(([, tags]) => {
      unsubscribeTcf.unsubscribe();
      tags.forEach((tag) => tag.destroy());
      unsubscribeTags.unsubscribe();
      onResize.unsubscribe();
      onUnload.unsubscribe();
    }),
  );
};
